<template>
  <section class="instagram" id="instagram">
    <div class="container fade-in">
      <div class="row text-center">
        <div class="col-12 slide-in from-right">
          <a href="https://www.instagram.com/haarlemfriseurehamburg/" target="_blank">
            <img src="../../../assets/images/insta_profile.png"
                 alt="Profilbild des Instagram Accounts von Haarlem Friseure">
          </a>
        </div>
        <div class="col-8 offset-2">
          <h1>Instagram Community</h1>
          <p>Lassen Sie sich von unserer aktuellen Zauberei inspirieren.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="instagram-feed">
            <ul class="juicer-feed" data-feed-id="haarlemfriseurehamburg" data-per="12"></ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Instagram",
  mounted() {
    let instagramScript = document.createElement('script')
    let instagramCss = document.createElement('link');
    instagramScript.setAttribute('src', 'https://assets.juicer.io/embed.js');
    instagramCss.setAttribute('href', 'https://assets.juicer.io/embed.css');
    instagramCss.setAttribute('rel', 'stylesheet');
    document.head.appendChild(instagramScript);
    document.head.appendChild(instagramCss);
  },
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

section {
  @include media-breakpoint-down(sm) {
    margin-top: 30px;
  }

  h1 {
    text-transform: uppercase;
    letter-spacing: 4px;
  }

  .juicer-feed .j-paginate {
    display: none;
  }
}

</style>
